export const exportHeaders = [
   
    {
        label: "Shipto",
        key: "customer_account_number"
    },

    {
        label: "Status",
        key: "is_active"
    },

    {
        label: "Created By",
        key: "email"
    },


    
]